import { defineCatalogue } from '../../i18n';

export const groupCatalogue = defineCatalogue(
  {
    'group.organisation': 'Organização',
    'group.campaign': 'Campanha',
  },
  {
    'group.organisation': 'Organisation',
    'group.campaign': 'Campaign',
  },
);

export const gt = groupCatalogue.t;
